import Table from './table.component';
import TableHeader from './table-header.component';
import TableRow from './table-row.component';
import TableColumn from './table-column.component';

export { Table, TableHeader, TableRow, TableColumn };
